import { render, staticRenderFns } from "./kefu.vue?vue&type=template&id=79325f70"
import script from "./kefu.vue?vue&type=script&lang=js"
export * from "./kefu.vue?vue&type=script&lang=js"
import style0 from "./kefu.vue?vue&type=style&index=0&id=79325f70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports